import React from "react";
import styled from "@emotion/styled";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";

import Button from "../Button";

function VirtualTourDialog(props: IVirtualTourDialog) {
  const { open, onClose, src } = props;

  return (
    <StyledDialog open={open} maxWidth="lg">
      <StyledHeader>
        <Button variant="text" colortext={"--color-gray-02"} onClick={onClose}>
          Cerrar
        </Button>
      </StyledHeader>
      <StyledContent>
        <iframe
          width="100%"
          height="100%"
          src={`${src}&play=0&qs=1`}
          frameBorder="0"
          allowFullScreen
        ></iframe>
      </StyledContent>
    </StyledDialog>
  );
}

interface IVirtualTourDialog {
  onClose: React.MouseEventHandler;
  open: boolean;
  src: string;
}

export default VirtualTourDialog;

const StyledDialog = styled(Dialog)`
  & .MuiDialog-paper {
    background-color: #efeff1;
    border-radius: 20px;
    width: 60%;
    height: 500px;

    @media screen and (max-width: 991px) {
      width: 90%;
    }

    @media screen and (max-width: 500px) {
      width: 100%;
      height: 300px;
      margin-right: 0;
      margin-left: 0;
    }
  }
`;

const StyledHeader = styled(DialogTitle)`
  text-align: right;
  font-size: 13px;
  color: var(--color-gray-01);
`;

const StyledContent = styled(DialogContent)`
  overflow: hidden;
`;
